import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavItem, NavLink } from 'reactstrap';
import {
    faCaretDown,
    faCaretUp,
    faWarning
} from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
export default function SideBarItem({ text, icon, link, onClick, submenu, collapsed, subItem, active, warning }) {

    return (
        <NavItem onClick={onClick} className={`sidebarItem ${active ? "active" : ""}`}>
            {link
                ? <NavLink tag={Link} to={link} className={`d-flex align-items-center justify-content-between`}>
                    {icon && <FontAwesomeIcon icon={icon} className={`iconSidebarItem ${subItem ? "submenuItem" : ""}`} />}
                    <p className={`textSidebarItem m-0 ${submenu ? "submenuItem" : ""} `}>{text}</p>
                    {warning && <span className='warning-sidebar'><FontAwesomeIcon icon={faWarning}/></span>}
                </NavLink>
                :
                <NavLink className="d-flex align-items-center justify-content-between">
                    {icon && <FontAwesomeIcon icon={icon} className=" iconSidebarItem" />}
                    <p className={`textSidebarItem ${submenu ? "submenu" : ""} m-0`}>{text}</p>
                    {submenu ? collapsed ? <FontAwesomeIcon icon={faCaretUp} className=" w-25" /> : <FontAwesomeIcon icon={faCaretDown} className=" w-25" /> : <></>}
                </NavLink>
            }

        </NavItem>
    )
}